export default __webpack_public_path__ + "static/media/payment-icon.5350401b.svg";